import React from 'react';
import { ObjectCardTile, type ObjectCardTone } from '../../../components/layout/ObjectCard';

interface CardSectionHeaderProps {
  title: string;
  subtitle?: string;
  hint?: string;
  icon?: React.ReactNode;
  tone?: ObjectCardTone;
}

/** Section title (15 px) with its icon tile, the one-line question it answers and a hint. */
const CardSectionHeader: React.FC<CardSectionHeaderProps> = ({ title, subtitle, hint, icon, tone }) => (
  <>
    <header className="obj-section__header product-card-section__header">
      {icon && <ObjectCardTile tone={tone} size="sm">{icon}</ObjectCardTile>}
      <h3 className="obj-section__title">{title}</h3>
      {subtitle && <span className="product-card-section__question">{subtitle}</span>}
    </header>
    {hint && <p className="product-card-section__hint">{hint}</p>}
  </>
);

export default CardSectionHeader;
